/**
 * Generate the route of an image based on if it is being hosted locally or not
 * @param imageName: filepath of image
 */
export function getImageSrc(imageName: string): string {
  if (window.location.hostname === 'localhost') {
    return `/assets/reviews/${imageName}`;
  }
  return `https://vstatic-prod.apigateway.co/reputation-client/assets/reviews/${imageName}`;
}

export const starCount = (stars: number): number[] => {
  return stars > 0 && stars <= 5
    ? Array(stars)
        .fill(1)
        .concat(Array(5 - stars).fill(0))
    : [];
};
